import * as React from "react"

const Button = (props) => {
    const Comp = "button"

    return (
        <Comp {...props} />
    );
}

Button.displayName = "Button"

export { Button }
